
import { supabase } from '@/integrations/supabase/client';

export interface DataExistenceCheck {
  table: string;
  exists: boolean;
  count?: number;
}

export class DataStateVerifier {
  static async verifyUserDataExists(): Promise<DataExistenceCheck[]> {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      throw new Error('Usuário não autenticado');
    }

    const tables = [
      'transactions',
      'accounts',
      'cards',
      'categories',
      'budgets',
      'goals',
      'debts',
      'future_releases',
      'credit_card_bills',
      'installment_groups'
    ];

    const checks: DataExistenceCheck[] = [];

    for (const table of tables) {
      try {
        const { count, error } = await (supabase as any)
          .from(table)
          .select('*', { count: 'exact', head: true })
          .eq('user_id', user.id);

        if (error) {
          console.warn(`Erro ao verificar tabela ${table}:`, error.message);
          checks.push({ table, exists: false, count: 0 });
        } else {
          const hasData = (count || 0) > 0;
          checks.push({ table, exists: hasData, count: count || 0 });
        }
      } catch (error) {
        console.warn(`Exceção ao verificar tabela ${table}:`, error);
        checks.push({ table, exists: false, count: 0 });
      }
    }

    return checks;
  }

  static async shouldSkipDeletion(table: string): Promise<boolean> {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return true;

      const { count, error } = await (supabase as any)
        .from(table)
        .select('*', { count: 'exact', head: true })
        .eq('user_id', user.id);

      if (error) {
        // Se erro for "relation does not exist" ou similar, assumir que não há dados
        if (error.code === 'PGRST116' || error.message.includes('does not exist')) {
          return true;
        }
        throw error;
      }

      return (count || 0) === 0;
    } catch (error) {
      console.warn(`Erro ao verificar se deve pular exclusão da tabela ${table}:`, error);
      return false; // Em caso de erro, tentar a exclusão mesmo assim
    }
  }
}
